import React from 'react';

const DoorClosedIcon = (props) => {
  const { className = '', style = {} } = props;

  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <path
        d="M14.3335 12.3307H12.0002V3.33073C12.0002 2.97656 11.6877 2.66406 11.3335 2.66406H4.66683C4.29183 2.66406 4.00016 2.97656 4.00016 3.33073V12.3307H1.66683C1.47933 12.3307 1.3335 12.4974 1.3335 12.6641V12.9974C1.3335 13.1849 1.47933 13.3307 1.66683 13.3307H14.3335C14.5002 13.3307 14.6668 13.1849 14.6668 12.9974V12.6641C14.6668 12.4974 14.5002 12.3307 14.3335 12.3307ZM11.0002 12.3307H5.00016V3.66406H11.0002V12.3307ZM9.66683 8.66406C10.021 8.66406 10.3335 8.3724 10.3335 7.9974C10.3335 7.64323 10.021 7.33073 9.66683 7.33073C9.29183 7.33073 9.00016 7.64323 9.00016 7.9974C9.00016 8.3724 9.29183 8.66406 9.66683 8.66406Z"
        fill="#4E758E"
      />
    </svg>
  );
};

export default DoorClosedIcon;
